export default "__VITE_ASSET__01fb2773__"